<template>
  <TheLayout>
    <div v-if="dataPermission && dataPermission.includes('NSH_MCMNT_LOCATION_VIEW')">
      <RowWrapper>
        <template #center>
          <titlePage :title="title"></titlePage>
        </template>
      </RowWrapper>

      <RowWrapper>
        <template #center>
          <div class="d-flex justify-content-end mb-3">
            <b-button
              variant="primary"
              @click="$router.push(`/location-list/location-create`)"
              v-if="dataPermission && dataPermission.includes('NSH_MCMNT_LOCATION_CREATE')">
              <i class="bx bx-plus font-size-16 align-middle mr-2"></i>
              Thêm chi nhánh
            </b-button>
          </div>
        </template>
      </RowWrapper>

      <CardWrapper>
        <RowWrapper>
          <template #center>
            <div class="row">
              <div class="col-md-10 col-12">
                <b-input-group class="wrapperInput">
                  <b-input-group-prepend>
                    <span class="input-group-text"
                      ><i class="fa fa-search fa-lg"></i
                    ></span>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="filter"
                    class="form-control f12 hc-37"
                    placeholder="Tìm kiếm theo tên, số điện thoại"
                    ref="searchFocus"
                  >
                  </b-form-input>

                  <div
                    class="removeText text-danger"
                    v-if="filter.length > 1"
                    @click="remove"
                  >
                    ×
                  </div>
                </b-input-group>
              </div>

              <div class="col-md-2 col-12">
                <b-button block variant="primary">Tìm kiếm</b-button>
              </div>
            </div>
          </template>
        </RowWrapper>
      </CardWrapper>

      <RowWrapper>
        <template #center>
          <div
            class="
              table-filter
              d-flex
              justify-content-start
              align-items-baseline
            "
          >
            <span>Thao tác nhanh:</span>
            <div class="col-lg-2 pb-4">
              <b-button
                variant="outline-danger"
                :disabled="selected.length > 0 ? false : true"
                @click="deleteSelected"
                v-if="
                  dataPermission &&
                  dataPermission.includes('NSH_MCMNT_LOCATION_DELETE')
                "
              >
                Xóa chi nhánh
              </b-button>
            </div>
          </div>
        </template>
      </RowWrapper>

      <CardWrapper>
        <RowWrapper>
          <template #center>
            <div class="table-responsive">
              <b-table
                hover
                head-variant="light"
                tbody-tr-class="row-table-class"
                :items="dataLocation"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template v-slot:head(selected)="data">
                  <BaseCheckbox
                    v-model="selectAll"
                    :value="data.item"
                  />
                </template>

                <template #cell(selected)="data">
                  <b-form-group class="mb-0">
                    <BaseCheckbox
                      v-model="selected"
                      :value="data.item"
                    ></BaseCheckbox>
                  </b-form-group>
                </template>

                <template #cell(name)="data">
                  <p
                    @click="$router.push(`/location-list/location-detail/${data.item.coLocationId}`)"
                    v-if="dataPermission && dataPermission.includes('NSH_MCMNT_LOCATION_VIEW')"
                    class="text-prim m-0"
                  >
                    {{ data.item.name }}
                  </p>
                  <span
                    class="badge badge-pill badge-success p-2"
                    v-if="data.item.isHeadQuarter == true"
                  >
                    Chi nhánh mặc định
                  </span>
                </template>

                <template #cell(address)="data">
                  {{ data.item.address }}
                  {{ data.item.ward ? ", " + data.item.ward : "" }}
                  {{ data.item.district ? ", " + data.item.district : "" }}
                  {{ data.item.province ? ", " + data.item.province : "" }}
                </template>

                <template #cell(action)="data">
                  <p class="d-flex p-0 justify-content-center">
                    <span
                      class="btn-sm btn-ext"
                      @click="$router.push(`/location-list/location-update/${data.item.coLocationId}`)"
                      v-if="dataPermission && dataPermission.includes('NSH_MCMNT_LOCATION_UPDATE')"
                    >
                      <i class='bx bx-pencil m-0'></i></span>
                    <span
                      class="btn-sm btn-ext"
                      @click="deleteItem(data.item)"
                      v-if="dataPermission && dataPermission.includes('NSH_MCMNT_LOCATION_DELETE')"
                    >
                      <i class='bx bx-trash m-0 text-danger'></i>
                    </span>
                  </p>
                </template>
              </b-table>
            </div>
          </template>
        </RowWrapper>
      </CardWrapper>

      <RowWrapper>
        <template #center>
          <div class="row d-flex justify-content-end mr-3">
            <div class="mr-3 d-flex">
              <p class="mr-2 mt-2" style="width: 100px">Hiển thị</p>
              <b-form-select v-model="perPage" :options="optionsPerPage" />
            </div>
            <div class="mr-3">
              <div class="mt-2">
                kết quả từ
                {{
                  currentPage * perPage - perPage + 1 > rows
                    ? rows
                    : currentPage * perPage - perPage + 1
                }}
                -
                {{
                  currentPage * perPage > rows ? rows : currentPage * perPage
                }}
                trên tổng {{ rows }} danh mục
              </div>
            </div>
            <div>
              <b-pagination
                pills
                hide-goto-end-buttons
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                align="right"
              >
              </b-pagination>
            </div>
          </div>
        </template>
      </RowWrapper>

      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>

<script>
import VueCookies from 'vue-cookies'
import titlePage from "@/components/title-page";
import RowWrapper from "@/components/wrappers/RowWrapper";
import CardWrapper from "@/components/wrappers/CardWrapper";
import Swal from "sweetalert2";

import { LocationService } from "@/services/nextshop/location.service";

export default {
  page: {
    title: "Thông tin doanh nghiệp",
  },
  components: {
    titlePage,
    RowWrapper,
    CardWrapper
  },

  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      loading: false,
      params: {
        merchantId: VueCookies.get('MID'),
        limit: 1000,
        page: 1,
        textSearch: null,
        sortBy: "name",
        sort: "ASC",
      },
      title: "QUẢN LÍ CHI NHÁNH",

      // Data Location
      dataLocation: [],
      selected: [],

      fields: [
        {
          key: "selected",
          label: "",
          thStyle: { width: "1%" },
        },
        {
          key: "name",
          label: "Tên chi nhánh",
          thStyle: { width: "5%" },
        },
        {
          key: "phoneNo",
          label: "Số điện thoại",
          thStyle: { width: "5%" },
        },
        {
          key: "email",
          label: "Email",
          thStyle: { width: "10%" },
        },
        {
          key: "address",
          label: "Địa chỉ",
          thStyle: { width: "10%" },
        },
        {
          key: "action",
          label: "Tác vụ",
          tdClass: "text-center",
          thClass: "text-center",
          thStyle: { width: "2%" },
        },
      ],

      optionsPerPage: [
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 5, text: "5" },
        { value: 10, text: "10" },
        { value: 30, text: "30" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      perPage: 10,
      currentPage: 1,
      filter: "",
      filterOn: [],
      totalRows: 1,
    };
  },

  created() {
    this.getListLocation();
  },

  computed: {
    selectAll: {
      get: function () {
        if (this.selected.length === this.dataLocation.length) {
          return "TRUE"
        } else if (this.selected.length === 0) {
          return "FALSE"
        } else {
          return "ORTHER"
        }
      },
      set: function (value) {
        var selected = []
        if (value) {
          this.dataLocation.forEach(function (item) {
            selected.push(item)
          })
        }
        this.selected = selected
      },
    },
    rows() {
      return this.dataLocation.length;
    },
  },

  methods: {
    // list location
    async getListLocation() {
      this.loading = true;
      try {
        const dataLocation = await LocationService.getListLocation(this.params);
        if (dataLocation.data.length == this.params.limit) {
          this.params.limit += 100;
          this.getListLocation();
        }
        if (dataLocation.success) {
          this.dataLocation = dataLocation.data;
          this.totalRows = this.dataLocation.length;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    remove() {
      this.filter = "";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      return this.dataLocation.length;
    },
    // modal => xoá location icon
    deleteItem(data) {
      Swal.fire({
        imageUrl: require("@/assets/images/exclamation-triangle.svg"),
        title:
          '<a style="color:#f46a6a; font-size:24px; font-family:BeVietnam">Xóa chi nhánh</<a>',
        text: `Chi nhánh này và mọi thông tin liên quan sẽ bị gỡ bỏ khỏi hệ thống`,
        confirmButtonText: "Xác nhận",
        confirmButtonColor: "#f46a6a",
        cancelButtonText: "Hủy",
        showCancelButton: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.deleteLocation([data.coLocationId]);
        }
      });
    },
  // xoá location
    async deleteLocation(params) {
      try {
        const data = await LocationService.deleteMultiLocation({
          locationIds: params
        });
        if (data.success) {
          Swal.fire({
            title: "Thành công",
            text: `Đã xóa thông tin thành công!`,
            icon: "success",
            confirmButtonText: "Xác nhận",
          }).then((result) => {
            if (result.value) {
              this.selected = []
              this.getListLocation();
            }
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    //modal => xoá location select
     async deleteSelected() {
      Swal.fire({
        title: "Xóa thông tin",
        text: `Xác nhận xóa thông tin?`,
        icon: "warning",
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        showCancelButton: true
      }).then((rel) => {
        if (rel.isConfirmed == true) {
          const mainLocation = this.selected.find(e => e.isHeadQuarter == true)
          if (mainLocation != undefined) {
            Swal.fire({
              title: "Lỗi",
              text: `Không thể xóa chi nhánh mặc định`,
              icon: "warning",
              showConfirmButton: false,
              showCancelButton: false,
            });
          } else {
            const removeIds = this.selected.map(e => e.coLocationId)
            this.deleteLocation(removeIds)
          }
        }
      })
    },
  },
};
</script>

